import type { FC, ReactNode } from "react";
import { Popover, type PopoverProps } from "react-aria-components";
import { menuStyle } from "./menuStyle.js";

/** Maximum height for menus expected to contain long option lists. */
export const longMenuMaxHeight = 480;

export interface SimpleMenuPopoverProps extends Omit<
  PopoverProps,
  "className"
> {
  children: ReactNode;
  /** Optional className applied to the Popover. Use to override the menu width. */
  className?: string;
  /**
   * Action area pinned below the menu, staying put while the options scroll
   * (see {@link SimpleMenuFooter}). Only the options scroll, so an action can't
   * be scrolled out of reach in a long menu.
   */
  footer?: ReactNode;
}

export const SimpleMenuPopover: FC<SimpleMenuPopoverProps> = ({
  children,
  className,
  footer,
  ...props
}) => {
  return (
    <Popover className={menuStyle().popover({ className })} {...props}>
      {footer === undefined ? (
        <div className={menuStyle().scrollContainer()}>{children}</div>
      ) : (
        <div className="flex max-h-[inherit] flex-col overflow-hidden rounded-[inherit]">
          <div
            className={menuStyle().scrollContainer({
              className: "max-h-none min-h-0 flex-1",
            })}
          >
            {children}
          </div>
          {footer}
        </div>
      )}
    </Popover>
  );
};
